import { ActionContext } from 'vuex';
import { IState } from '@app/store';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { IAuthenticationState } from '@store/modules/data/authentication/authenticationIndex';

type Context = ActionContext<IAuthenticationState, IState>;
export type ReKycStatusType = 'PENDING' | 'FAILED' | 'EXPIRED' | 'OK';

export function processReKycModals(context: Context, reKycStatus: ReKycStatusType): void {
    if (reKycStatus === 'PENDING' || reKycStatus === 'FAILED') {
        context.dispatch(
            'ui/modal/pushModal',
            {
                code: modalCodes.personalDataValidationModal,
                isClosable: false,
            },
            { root: true },
        );
    } else if (reKycStatus === 'EXPIRED') {
        context.dispatch(
            'ui/modal/pushModal',
            {
                code: modalCodes.idCardVerificationReKyc,
                isClosable: false,
            },
            { root: true },
        );
    }
}
